<!-- @format -->
<template>
	<el-tabs v-model="activeTab" stretch class="setting-container-tabs">
		<el-tab-pane label="组件设置" name="field">
			<Field
				v-if="activeTab === 'field'"
				:can-change-field="canChangeField"
				@on-attribute-change="emit('on-attribute-change', $event)"
			/>
		</el-tab-pane>
		<el-tab-pane v-if="canFormAttribute" label="表单设置" name="form">
			<Form v-if="activeTab === 'form'" />
		</el-tab-pane>
	</el-tabs>
</template>

<script setup lang="ts">
	import ScriptList from '../../utils/script';
	import Field from './field/index.vue';
	import Form from './form/index.vue';
	import type { ScriptFuncType } from '../../types';

	interface Props {
		otherFunc?: ScriptFuncType;
		name?: string;
		canFormAttribute?: boolean;
		canChangeField?: boolean | ((a: any) => boolean);
	}

	const props = withDefaults(defineProps<Props>(), {
		canFormAttribute: true,
	});

	const emit = defineEmits(['on-delete', 'on-attribute-change']);

	const activeTab = ref('field');

	const scriptConfig = new ScriptList(ref({}), ref([]), props.otherFunc);

	provide('scriptConfig', scriptConfig);

	// store唯一值
	provide('name', props.name);
</script>

<style scoped lang="scss">
	.setting-container-tabs {
		height: 100%;

		:deep(.el-tabs__content) {
			height: calc(100% - 54px);
			overflow-y: scroll;
		}
	}
</style>
